import { Fragment } from "react";
import classNames from "classnames";
import { CircularProgress as MuiCircularProgress } from "@mui/material";
import styles from "./loader.styles.module.scss";
import { LoaderProps } from "./loader.types";

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const Loader = ({
  btnClass = "",
  rootClassName = "",
  size = 24,
  source = "",
  variant = "indeterminate",
  ariaLabel = undefined,
}: LoaderProps) => {
  return (
    <Fragment>
      <MuiCircularProgress
        className={classNames(btnClass, rootClassName, styles.top, source === "button" && styles.btnLoader)}
        size={size}
        variant={variant}
        aria-label={ariaLabel}
      />
    </Fragment>
  );
};

export default Loader;
